export const handleFilters = (data, filters, license = false) => {
    const filtered = data.filter(item => {
        return Object.entries(filters).every(([key, filter]) => {
            if (key === "project") {
                if (!filter?.value) return true;
                if (typeof filter.value === 'string') {
                    return item.name.toUpperCase().includes(filter.value.toUpperCase());
                } else {
                    return item[key] === filter.value;
                }
            } else if (key === "modality") {
                if (filter.length === 0) return true;
                return filter.some(f => f.value === item[key]);
            } else if (key === "resales") {
                if (filter.length === 0) return true;
                return filter.some(f => item[key].split(",").some(r => r.trim() === f.label));
            }

            if (!item[key]) return false;

            return item[key].toLowerCase().includes(filter.toLowerCase());
        });
    });

    if (license){
        return filtered.filter(item => item.dead_file === false)
    }else{
        return filtered
    }
}
